<template>
  <div class="social-shares d-flex align-items-center">
    <span class="mr-2 small">Share this:</span>
    <ShareNetwork
      network="facebook"
      :url="serviceUrl"
      :title="service.name"
      :description="shortDescription"
    >
      <b-icon icon="facebook" class="mr-2"></b-icon>
    </ShareNetwork>
    <ShareNetwork
      network="WhatsApp"
      :url="serviceUrl"
      :title="service.name"
      :description="shortDescription"
    >
      <b-icon icon="chat-fill" class="mr-2"></b-icon>
    </ShareNetwork>
    <ShareNetwork
      network="twitter"
      :url="serviceUrl"
      :title="service.name"
      :description="shortDescription"
    >
      <b-icon icon="twitter" class="mr-2"></b-icon>
    </ShareNetwork>
    <ShareNetwork
      network="email"
      :url="serviceUrl"
      :title="service.name"
      :description="shortDescription"
    >
      <b-icon icon="envelope-fill" class="mr-2"></b-icon>
    </ShareNetwork>
  </div>
</template>

<script>
export default {
  name: 'SocialActions',
  props: {
    service: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    serviceUrl() {
      return window.location.href
    },
    shortDescription() {
      return this.service.description.replace(/(<([^>]+)>)/gi, '').substring(0, 100) + '...'
    },
  },
}
</script>
